/**
 * FeaturesSection
 *
 * "Why MomentSent" — six feature tiles in a responsive 3-column grid.
 * Sits between HowItWorks and PricingTeaser on the landing page.
 */

const FEATURES = [
  {
    emoji: '✉️',
    title: 'A message that sounds like you',
    body:  'You write the message in your own words, exactly what you\'d say if you were writing it by hand. We print it on a real card and mail it, so every word is genuinely from you.',
  },
  {
    emoji: '📬',
    title: 'Real cards. Real mail.',
    body:  'Not an e-card. A real printed card, stamped and mailed to their actual address, just like you sent it yourself.',
  },
  {
    emoji: '🔄',
    title: 'Recurring or one-time, your call',
    body:  'Set a birthday once and a card goes out every year automatically. Or schedule a one-time card for any moment, a thinking-of-you, a graduation, a get-well-soon. Both work exactly the same way.',
  },
  {
    emoji: '🌍',
    title: 'Ships worldwide',
    body:  'Family overseas? No problem. We mail to 100+ countries through our global print partners, with full tracking support.',
  },
  {
    emoji: '💌',
    title: 'Real folded cards, in an envelope',
    body:  'Not a postcard. Every send is a folded greeting card printed on premium cardstock, tucked into a sealed envelope, and mailed first-class. The kind of card people stand up on a shelf.',
  },
  {
    emoji: '📱',
    title: 'Mobile app, coming soon',
    body:  'An iOS and Android app is in the works. Manage contacts, review upcoming cards, and approve sends from your phone, right where life happens.',
  },
] as const;

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 bg-cream">
      <div className="section-container">

        {/* Heading */}
        <div className="text-center mb-16">
          <p className="font-body text-xs font-semibold tracking-widest text-sage uppercase mb-3">
            Why MomentSent
          </p>
          <h2 className="section-heading text-4xl sm:text-5xl">
            Everything handled.<br className="hidden sm:block" /> Nothing forgotten.
          </h2>
          <p className="mt-4 font-body text-gray-500 text-base max-w-lg mx-auto leading-relaxed">
            MomentSent does the work so you get the credit, and the person you care about
            gets a real card in their mailbox, right on time.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="card p-7 group hover:shadow-warm-lg transition-shadow duration-300"
            >
              <div className="text-4xl mb-5">{f.emoji}</div>
              <h3 className="font-heading text-lg text-navy mb-2.5">{f.title}</h3>
              <p className="font-body text-sm text-gray-500 leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-14 text-center">
          <div className="inline-flex items-center gap-2 bg-white rounded-full px-6 py-3 shadow-warm">
            <span className="text-lg">💳</span>
            <p className="font-body text-sm text-navy">
              <span className="font-semibold">No credit card required.</span>
              {' '}Start your 14-day free trial in seconds.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
